// These are values set in legacy corps.model.ts that are never changed in any flow
export const defaultCorpValues = {
  allowPickupLevel: 'FIRM',
  invoiceContactCountry: 'United States',

  uri: '',
  financeFeeGraceDays: 1,
  financeFeeAnnualRate: 0,
  minStartDate: new Date().toISOString(),
  selectFirmLocationOnOrder: false,
  defaultTerms: 2,
  allocationsReportingEnabled: false,
  corpNextAutopay: new Date().toISOString(),
  invoiceContactCcEmails: [],
  defaultReasonName: '',
  predefinedReasons: [
    {
      name: '',
      reason: '',
    },
  ],
};
